import { Button, PageHeader } from '@repo/ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { SchedulingProfilesSection } from '@/features/appointments/scheduling-profiles-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/agendamentos/perfis')({
  component: SchedulingProfilesPage,
})

function SchedulingProfilesPage() {
  const { currentOrgId } = useAuth()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <PageHeader
        title="Perfis de agendamento"
        description="Configure perfis de disponibilidade e regras de agendamento."
        back={
          <Button
            type="button"
            variant="ghost"
            size="icon"
            title="Voltar para Agendamentos"
            onClick={() => void navigate({ to: '/agendamentos' })}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
        }
      />

      <div className="flex-1 overflow-y-auto p-6">
        {currentOrgId ? (
          <SchedulingProfilesSection orgId={currentOrgId} />
        ) : null}
      </div>
    </div>
  )
}
